import axios from 'axios';
import Cookies from "universal-cookie";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

// Create axios instance with default config
const conversationAPI = axios.create({
    baseURL: API_BASE,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests
conversationAPI.interceptors.request.use((config) => {
    const token = getToken();
    
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
});

// Conversation API endpoints
export const getProjectConversations = async (projectUuid) => {
    const response = await conversationAPI.get(`/projects/${projectUuid}/conversations`);
    return response.data;
};

export const getConversation = async (conversationUuid) => {
    const response = await conversationAPI.get(`/conversations/${conversationUuid}`);
    return response.data;
};

export const createConversation = async (projectUuid, conversationData) => {
    const response = await conversationAPI.post(`/projects/${projectUuid}/conversations`, conversationData);
    return response.data;
};

export const updateConversation = async (conversationUuid, conversationData) => {
    const response = await conversationAPI.put(`/conversations/${conversationUuid}`, conversationData);
    return response.data;
};

export const deleteConversation = async (conversationUuid) => {
    const response = await conversationAPI.delete(`/conversations/${conversationUuid}`);
    return response.data;
};

// Notes API endpoints
export const getConversationNotes = async (conversationUuid) => {
    const response = await conversationAPI.get(`/conversations/${conversationUuid}/notes`);
    return response.data;
};

export const createNote = async (conversationUuid, noteData) => {
    const response = await conversationAPI.post(`/conversations/${conversationUuid}/notes`, noteData);
    return response.data;
};

export const updateNote = async (noteUuid, noteData) => {
    const response = await conversationAPI.put(`/notes/${noteUuid}`, noteData);
    return response.data;
};

export const deleteNote = async (noteUuid) => {
    const response = await conversationAPI.delete(`/notes/${noteUuid}`);
    return response.data;
};

// Note read status endpoints
export const markNoteAsRead = async (noteUuid) => {
    const response = await conversationAPI.post(`/notes/${noteUuid}/mark-read`);
    return response.data;
};

export const markNoteAsUnread = async (noteUuid) => {
    const response = await conversationAPI.post(`/notes/${noteUuid}/mark-unread`);
    return response.data;
};

export const markAllNotesAsRead = async (conversationUuid) => {
    const response = await conversationAPI.post(`/conversations/${conversationUuid}/mark-all-read`);
    return response.data;
};

// Get conversations with latest notes for bento grid
export const getProjectConversationsWithLatestNotes = async (projectUuid) => {
    const response = await conversationAPI.get(`/projects/${projectUuid}/conversations/with-latest-notes`);
    return response;
};

// Get unread notes count for a project
export const getUnreadNotesCount = async (projectUuid) => {
    const response = await conversationAPI.get(`/projects/${projectUuid}/conversations/unread-count`);
    return response.data;
};